// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3b7uZ","footer":"ModalUpdate_footer__hY36w"};